import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GitlabService } from '../../services/gitlab.service';
import {
  GitlabVersionUpgradeStatus,
  ResetDeployDevStatusDto,
  ResetDeployInfoEntity, ResetDeploymentEntity
} from '../../model/GitlabVersionModel';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-gitlab-version',
    templateUrl: './gitlab-version.component.html',
    styleUrls: ['./gitlab-version.component.sass'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class GitlabVersionComponent implements OnInit {

  public newVersion: string;
  public status: GitlabVersionUpgradeStatus = null;
  public devDeployDevStatus: ResetDeployDevStatusDto = null;

  public deployables: ResetDeployInfoEntity[] = [];
  public deployablesPerType: Record<string, ResetDeployInfoEntity[]>;

  public deploymentTypes: string[] = ['DOCKER', 'BACKEND', 'FRONTEND'];
  public gitCommitHashToNames: Record<string, string> = {};

  constructor(
    private gitlabService: GitlabService,
    private notificationService: ToastrService
  ) {

    this.deployablesPerType = {};
    this.deploymentTypes.forEach(dt => this.deployablesPerType[dt] = []);
  }

  ngOnInit(): void {
    this.refreshDeployables();
  }

  upgrade() {
    this.gitlabService.postNewVersion(this.newVersion).subscribe({
      next: res => {
        this.status = res;
        this.notificationService.success('upgraded version');
      },
      error: error => {
        this.notificationService.error(error, 'error while upgrading',);
      }
    });
  }

  devToDeployDev() {
    this.gitlabService.deployDevToDeployDev().subscribe({
      next: res => {
        this.devDeployDevStatus = res;
        this.notificationService.success('pushed to deploy_dev');
        this.refreshDeployables();
      },
      error: error => {
        this.notificationService.error(error, 'error while pushing dev to deploy_dev');
      }
    });
  }

  private refreshDeployables() {
    this.gitlabService.getDeployables().subscribe(res => {

      this.deployables = res;
      this.deploymentTypes.forEach(dt => {
        this.deployablesPerType[dt] = res.filter(r => r.end === dt);
        this.deployablesPerType[dt].sort((x, y) => y.id - x.id);
        this.deployablesPerType[dt].forEach(deployable => {
          deployable.deployments.sort((d1, d2) => d2.id - d1.id);
        });
      });
    });
    this.gitlabService.getGitCommitHashToNames().subscribe(res => {
      this.gitCommitHashToNames = res;
    });
  }

  stringify(obj: unknown) {
    return JSON.stringify(obj);
  }

  isSuccess(deployment: ResetDeploymentEntity): boolean {
    let succ = true;
    deployment.commands.forEach(command => {
      if (command.exitcode !== 0 && !command.command.startsWith('sha512sum ')) {
        succ = false;
      }
    });
    return succ;
  }

  deploy(stage: string, deployable: ResetDeployInfoEntity) {
    this.gitlabService.deployProd(stage, deployable.hash).subscribe({
      next: res => {
        this.notificationService.success('deployed ' + this.stringify(res));
        this.refreshDeployables();
      }, error: error => {
        this.notificationService.error(error, 'failed to deploy');
      }
    });
  }
}
